var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTele(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#27AE60",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.667 11.8334H22.667",
    stroke: "#008633",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 9.33337V14.3334",
    stroke: "#008633",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0314 19.1965L16.1858 20.0421C15.1686 19.5675 14.2947 18.9903 13.6491 18.351C12.6847 17.396 12.1689 16.363 11.9579 15.8143L12.8035 14.9686C13.037 14.7351 13.037 14.3565 12.8035 14.1231L10.6896 12.0091C10.4561 11.7756 10.075 11.7723 9.84988 12.0139C8.5612 13.3968 6.97757 15.9073 11.5352 20.4649C16.0928 25.0225 18.6033 23.4388 19.9861 22.1502C20.2277 21.925 20.2244 21.544 19.9909 21.3105L17.877 19.1965C17.6435 18.963 17.2649 18.963 17.0314 19.1965Z",
    stroke: "#1EB865",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTele);
export default __webpack_public_path__ + "static/media/tele.8e3dfec36dc99747ae4a2a09563a426b.svg";
export { ForwardRef as ReactComponent };